import React, { Component } from 'react';
import shortid from 'shortid';
import _ from 'lodash';

// Components
import Dropzone from 'react-dropzone';
import Button from '../button';
import { Loader } from '../loader';
import { storage } from 'core/firebase';
import styles from './image-avatar.scss';
import { ICON_EDIT } from 'icons';

type Icon = { bucket: string, path: string };

function iconUrl(icon: Icon) {
  if (!icon) return '/static/sample-image.svg';
  return typeof icon === 'string' ? icon : `//storage.googleapis.com/${icon.bucket}/${icon.path}`;
}

type Props = {
  disabled: Boolean,
  image: String,
  label?: String,
  small?: Boolean,
  primary: Boolean,
  disabled: Boolean,
  className?: String,
  onChange: (image: String) => void
};
type State = {};
export default class ImageAvatar extends Component {
  props: Props;
  state: State = {
    uploading: false,
    error: false
  };

  handleImageDrop = async(files: File[]) => {
    const file = files[0];
    if (!file) return;

    this.setState({ uploading: true });
    const ext = _.last(file.name.split('.'));
    const fileRef = storage.ref(`avatar/${shortid.generate()}.${ext}`);

    try {
      await fileRef.put(file);
      this.props.onChange(`https://storage.googleapis.com/${fileRef.bucket}/${fileRef.fullPath}`);
      this.setState({ uploading: false, error: false });
    } catch (error) {
      console.error('Error uploading icon', error);
      this.setState({ uploading: false, error });
    }
  };

  render() {
    const { image, label, small, primary, className, onChange, onClick } = this.props;
    const { uploading, error } = this.state;
    const disabled = this.props.disabled || uploading || !onChange;

    let cl = styles.icon + ' layout-column layout-center-center';
    if (small) cl += ' ' + styles.small;
    if (disabled) cl += ' ' + styles.disabled;
    if (className) cl += ' ' + className;
    if (primary) cl += ' ' + styles.primary;

    const style = {};
    if (image) style.backgroundImage = `url(${iconUrl(image)})`;
    if (!onChange) return <div onClick={onClick} className={cl} style={style} />;

    return (
      <Dropzone
        disabled={disabled}
        disableClick={disabled}
        onClick={onClick}
        onDrop={this.handleImageDrop}
        className={styles.root + ' layout-column layout-center-center layout-margin'}
        accept={'image/*'}
      >
        <div className={cl} style={style}>
          {uploading && <Loader />}
        </div>
        {!small && (
          <Button
            icon={ICON_EDIT}
            flat={label || 'Change image'}
            primary
            disabled={uploading || disabled}
          />
        )}
        {error && <small className="text-error">{error}</small>}
      </Dropzone>
    );
  }
}
